import { OptimizelyActionTypes } from './types';
var initialState = {
    tourOperatorCodes: ''
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case OptimizelyActionTypes.CHANGE_TOUR_OPERATOR_CODES:
            return {
                tourOperatorCodes: action.tourOperatorCodes
            };
        default: {
            return state;
        }
    }
};
export { reducer as optimizelyReducer };
